import { MouseEvent, ChangeEvent, useState, useEffect } from 'react';
import CloseIcon from '../icons/CloseIcon';
import SearchIcon from '../icons/SearchIcon';
import { formActions, rootActions, useAppDispatch, useAppSelector } from '../../data/store';
import { getIconByKey, searchIcons } from '../../domain/icons-provider';
import { getIconsData } from '../../data/data-provider';

interface ISavedIconsPopup {
    setPopupShown: Function
}

const SearchIconsPopup = (props: ISavedIconsPopup) => {

    const dispatch = useAppDispatch();
    const iconsData = useAppSelector(store => store.root.iconsData);
    const searchTerm = useAppSelector(store => store.form.searchTerm);

    const [filteredIcons, setFilteredIcons] = useState<string[]>([]);

    const close = () => {
        props.setPopupShown(false);
    };

    const prevent = (evt: MouseEvent) => {
        evt.stopPropagation();
    };

    useEffect(() => {
        const search = (term: string) => {
            const filtered = searchIcons(iconsData, term);
            setFilteredIcons(filtered);
        };

        search(searchTerm);
    }, [searchTerm, iconsData]);

    const onInputHandler = (evt: ChangeEvent<HTMLInputElement>) => {
        dispatch(
            formActions.main({
                searchTerm: evt.target.value,
            })
        );
    };

    const selectIcon = async (iconKey: string) => {
        const icon = await getIconByKey(getIconsData(), iconKey);

        dispatch(
            rootActions.main({
                randomIcon: icon,
            })
        );

        close();
    };

    return (
        <div
            className="fixed bg-black/75 w-screen h-screen left-0 top-0 z-50 flex items-center justify-center"
            onClick={ close }>

            <div
                className="bg-white text-gray-900 rounded-xl relative"
                style={{
                    width: '590px',
                    maxWidth: '95%',
                }}
                onClick={ prevent }>

                <button
                    type="button"
                    className="cursor-pointer absolute right-2 top-2"
                    onClick={ close }>
                    <CloseIcon />
                </button>

                <div className="p-10">
                    <p className="text-2xl mb-6">Search Icons</p>

                    <div className="flex border rounded px-4 py-3 w-full mb-6">
                        <div className="mr-4">
                            <SearchIcon />
                        </div>
                        <input
                            type="text"
                            value={ searchTerm }
                            className="flex-1 outline-0"
                            placeholder="Search Tabler Icons"
                            onInput={ onInputHandler }
                        />
                    </div>

                    <div className="overflow-y-auto grid grid-cols-4 gap-4 mb-6 justify-center items-center" style={{
                        height: '200px',
                    }}>
                        {
                            filteredIcons.length > 0 && filteredIcons.map(iconKey => {
                                return (
                                    <button
                                        type="button"
                                        className="flex flex-col justify-center items-center"
                                        title={ iconKey }
                                        key={ iconKey }
                                        onClick={ () => {
                                            selectIcon(iconKey);
                                        }}>
                                        <i className={`ti ti-${ iconKey } text-4xl`}></i>
                                        {/* <span className="text-sm">{ iconKey }</span> */}
                                    </button>
                                )
                            })
                        }

                        {
                            filteredIcons.length === 0 && searchTerm === '' && (
                                <p className="col-start-1 col-end-5 text-center">Search for Tabler icons.</p>
                            )
                        }

                        {
                            filteredIcons.length === 0 && searchTerm !== '' && (
                                <p className="col-start-1 col-end-5 text-center">No results.</p>
                            )
                        }

                    </div>

                    <div>
                        <button type="button" className="bg-sky-700 text-gray-100 px-16 py-3 rounded-full" onClick={ close }>Close</button>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default SearchIconsPopup;